import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Card, CardBody, CustomInput } from "reactstrap";
import GeneralGrid from "../../Components/GeneralGrid";
import PhaseSettingsModal from "./PhaseSettingsModal";

const PhasesCard = ({
  phases,
  partnerScenarioId,
  reloadList,
  onItemDeteled,
}) => {
  let [selectedPhase, setSelectedPhase] = useState(undefined);
  let [isPhaseModalOpen, setIsPhaseModalOpen] = useState(false);
  const phaseColumns = [
    {
      dataField: "icon",
      text: "Icon",
      sort: false,
      headerStyle: () => {
        return { width: "20%" };
      },
      formatter: (cellContent, row) => {
        if ((typeof(cellContent) !== 'string') || cellContent.length === 0)
          return null;
          
        return (
          <img width={20} height={20}
            src={cellContent}
            alt="icon"
            onClick={() => goToPhase(row.phaseID)}
          />
        );
      },
    },
    {
      dataField: "phaseText",
      text: "Phase",
      sort: false,
      headerStyle: () => {
        return { width: "40%" };
      },
      formatter: (cellContent, row) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            key={"x" + row.phaseID}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              goToPhase(row.phaseID);
            }}
          >
            {cellContent}
          </a>
        );
      },
    },
    {
      dataField: "scoreAlternatives",
      text: "Score Alternatives",
      sort: false,
      headerStyle: () => {
        return { width: "40%" };
      },
      formatter: (cellContent, row) => {
        return (
          <CustomInput
            readOnly={true}
            type="checkbox"
            id={`scoreAlt-${row.rowID}`}
            checked={row.scoreAlternatives}
          />
        );
      },
    },
  ];

  const goToPhase = (phaseID) => {
    let phase;
    if (phaseID === -1) { // user adding new phase
      const maxOrderID = phases.length === 0 ? -1 : Math.max(...phases.map(p => p.orderID));
      phase = {
        phaseID: -1,
        partnerScenarioID: partnerScenarioId,
        phaseText: "",
        orderID: maxOrderID + 1,
        scoreAlternatives: false,
        icon: "",
        introText: "",
        unlockMessage: "",
        milestoneScreenType: "List",
        lockReason: ""
      }
    } else {
      phase = phases.find(p => p.phaseID === phaseID);
    }

    setSelectedPhase(phase);
    togglePhaseModal();
  };

  const togglePhaseModal = () => {
    setIsPhaseModalOpen(!isPhaseModalOpen);
  }

  return (
    <>
      <Card className="main-card mb-3">
        <CardBody>
          <GeneralGrid
            colWidth={12}
            title={"Phases"}
            keyField="phaseID"
            dataSource={phases}
            columns={phaseColumns}
            defaultSortedColumn="orderID"
            showAddButton={true}
            buttonText={"Add Phase"}
            onAdd={() => {
              goToPhase(-1);
            }}
          />
        </CardBody>
      </Card>

      <PhaseSettingsModal
        showModal={isPhaseModalOpen}
        toggleModal={togglePhaseModal}
        phaseItem={selectedPhase}
        reloadList={reloadList}
        onItemDeteled={onItemDeteled}
      />
    </>
  )
};

export default PhasesCard;